import { RainInputsPropsType } from "./types";
import { useTranslation } from "react-i18next";
import "./i18n";
import { Field } from "react-final-form";
import { DatePicker } from "@pickit/pickit-components";
import { DATE_FORMATS } from "utils/constants";
import { TimeInput } from "component/inputs/TimeInput";
export const RainInputs = ({
  disabled = false,
  limitDates,
  disableDate,
  form,
  testId,
  onBlur,
}: RainInputsPropsType): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <div className="container-modal-rain-form-col-1">
        <Field
          type="text"
          name="rainDate"
          className="Admin-Pickers-input"
          placeholder={t("rainInputs:datePlaceholder")}
          label={t("rainInputs:dateLabel")}
          language="es"
        >
          {(props: any) => (
            <div>
              <DatePicker
                singleSelection
                outputFormat={DATE_FORMATS.shortDate}
                minDate={limitDates?.minDate}
                maxDate={limitDates?.maxDate}
                overAll
                disabled={disabled || disableDate}
                testId={`${testId}-date`}
                onChange={() => {
                  onBlur();
                  form?.mutators.setValue();
                }}
                {...props}
              />
            </div>
          )}
        </Field>
      </div>
      <div className="container-modal-rain-form-col-1">
        <Field
          type="text"
          name="rainTime.initial"
          label={t("rainInputs:rainTimeStartLabel")}
          component={TimeInput}
          disabled={disabled}
          className="Admin-Pickers-input"
          language="es"
          placeholder={t("rainInputs:rainTimeStartPlaceholder")}
          onChange={form?.mutators.setValue}
          onBlur={onBlur}
          testId={`${testId}-start-time`}
        />
      </div>
      <div className="container-modal-rain-form-col-1">
        <Field
          type="text"
          name="rainTime.end"
          label={t("rainInputs:rainTimeEndLabel")}
          component={TimeInput}
          disabled={disabled}
          className="Admin-Pickers-input"
          language="es"
          placeholder={t("rainInputs:rainTimeEndPlaceholder")}
          onChange={form?.mutators.setValue}
          onBlur={onBlur}
          testId={`${testId}-end-time`}
        />
      </div>
    </>
  );
};
